import React, { useEffect, useState } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    NumberInput,
    Show,
    SelectArrayInput,
    List,
    TextField,
    NumberField,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton,
    Datagrid,
    EditButton,
} from 'react-admin';

const ListActions = () => {
    return(
        <TopToolbar>
            <CreateButton />
            {/*<FilterButton />*/}
            <ExportButton />
        </TopToolbar>
    );
}


export const OperatorList = () => {

    return (
        <List
            actions={<ListActions/>}
        >
            <Datagrid bulkActionButtons={false} >
                <TextField source="id" />
                <TextField source="name"  />
                <TextField source="host" />
                <EditButton />
            </Datagrid>
        </List>
    );
}
